<template>
  <div>
    <!-- 视频语音播放 -->
    <Modal v-model="pass2.model2" width="830" :closable="false" :mask-closable="false">
       <p slot="header" style="color:#f60;text-align:center">
        <Icon type="md-information-circled"></Icon>
        <span>{{pass2.content}}</span>
      </p>
      <div style="text-align: center;">
        <video id="play" width="500" height="300" controls="controls" v-if="pass2.content=='视频介绍'"></video>
        <audio id="play" width="500" height="300" controls="controls" v-if="pass2.content=='语音介绍'"></audio>
      </div>
      <div slot="footer">
        <Button  type='primary'  @click="handlePass2">播放</Button>
        <Button  type='default'  @click="handleCancel">取消</Button>
      </div>
    </Modal>
   
  </div>
</template>
<script>
export default {
  data() {
    return {
        video:'',
      pass2:{
        model2: false,
        kv: null,
        content: '',
      },
    }
  },

  created() {
  },
  mounted() {
  },
  methods: {
    handlePass2(){
      let q = {}
      q.kv = this.pass2.kv
      let url = this.pass2.kv
      console.log(q,'4444444');
      this.video = url;
      videoElem = document.getElementById("play").src = url;
      videoElem = document.getElementById("play").play();
      this.$set(this.pass2, 'sloading', true)
    },
    handleCancel(){
      videoElem = document.getElementById("play").pause();
      this.pass2.model2 = false
      console.log(123456);
    },
  },
}
</script>
<style lang="less">
</style>
